// @ngInject
Filters.EncodeURIFilter = ($window) => {
    return (uri) => {
        return $window.encodeURIComponent(uri);
    };
};